var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngularjs60989Ab0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21376d",
    d: "M18.285 24h8.811l-4.684-9.862L18.285 24zm4.143-24L0 7.948l3.544 29.588L22.452 48l19.005-10.606L45 7.807 22.428 0zm-5.967 28.192-2.75 6.927-5.14.021 13.856-30.9-.027-.058h-.024v-.051l.024.051h.053l.047-.104v.104h-.047l-.026.058 14.454 31.029-4.948-.109-3.044-7.081-6.5.031-5.928.082z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularjs60989Ab0);
export default __webpack_public_path__ + "static/media/angular.js.60989ab0.627b9a8874b9abf60cb8d8c79df52426.svg";
export { ForwardRef as ReactComponent };